<template>
    <div id="bellin-alert" v-if="show">
      <hp5-alert type="info" hide-alert-text :show-alert="true">
        Change in referral policy: To get in-network cost coverage, Bellin employees who get their insurance through work will need a referral before
        seeing specialists.
        <a href="https://bellinbenefits.org/benefits/bellinfirst-medical-plan/" target="_blank">Learn more about this change</a>
      </hp5-alert>
    </div>
</template>
  
<script setup>
      const { profile, plan } = useFCPModel()
      const show = computed(() => profile.value.hasAnyBellinCoverage && plan.value.networkSpecificMessage != null)
</script>